import React from "react";

import PlanEdit from "app/setup/modules/operator/features/managePlan/subFeatures/planEdit";

const OperatorPlanEdit = () => {
  return <PlanEdit />;
};

export default OperatorPlanEdit;
